import {Pressable, Text, View, TextInput} from "react-native";
import React from "react";
import {styles} from "./styles";
import {i18n} from "./localization";
import {BaseModal} from "./BaseModal";

export const ConfirmationModal = ({ visible, text, okText, onPressOk, onPressClose, isRestaurant = false }) => {
    const [notes, setNotes] = React.useState('');

   const handleOk = () => {
        onPressOk(isRestaurant ? notes : undefined);
        setNotes('');
    };

    const handleClose = () => {
        setNotes('');
        onPressClose();
    };

    return (
         <BaseModal visible={visible} onPressClose={onPressClose}>
             <Text style={styles.baseModal.modalText}>
                 {text}
             </Text>

            {isRestaurant && (
                  <View >
                    <TextInput
                        value={notes}
                        onChangeText={setNotes}
                        placeholder={i18n.t("notesPlaceholder")}
                        multiline
                        numberOfLines={3}
                        maxLength={300}
                        style={styles.textArea}
                        textAlignVertical="top"
                        returnKeyType="done"
                        blurOnSubmit
                    />
                   </View>
            )}

             <View style={{width: "100%", flexDirection: "row", marginTop: 20,}}>
                <Pressable onPress={handleOk} style={{...styles.button, width: "50%"}}>
                     <Text style={styles.buttonText}>{okText}</Text>
                 </Pressable>
                <Pressable onPress={handleClose} style={styles.confirmationModal.cancelButton}>
                     <Text style={styles.confirmationModal.cancelButtonText}>{i18n.t("cancel")}</Text>
                 </Pressable>
             </View>
         </BaseModal>
     )
}
